export default __webpack_public_path__ + "media/images/icons/check-749802a53e88a219e0031db614af1e54.svg";